(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('rpt-compendium-default-message', {
            parent: 'entity',
            url: '/rpt-compendium-default-message',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'RptCompendiumDefaultMessages'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/rpt-compendium-default-message/rpt-compendium-default-messages.html',
                    controller: 'RptCompendiumDefaultMessageController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('rpt-compendium-default-message-detail', {
            parent: 'entity',
            url: '/rpt-compendium-default-message/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'RptCompendiumDefaultMessage'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/rpt-compendium-default-message/rpt-compendium-default-message-detail.html',
                    controller: 'RptCompendiumDefaultMessageDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'RptCompendiumDefaultMessage', function($stateParams, RptCompendiumDefaultMessage) {
                    return RptCompendiumDefaultMessage.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'rpt-compendium-default-message',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('rpt-compendium-default-message-detail.edit', {
            parent: 'rpt-compendium-default-message-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/rpt-compendium-default-message/rpt-compendium-default-message-dialog.html',
                    controller: 'RptCompendiumDefaultMessageDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['RptCompendiumDefaultMessage', function(RptCompendiumDefaultMessage) {
                            return RptCompendiumDefaultMessage.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('rpt-compendium-default-message.new', {
            parent: 'rpt-compendium-default-message',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/rpt-compendium-default-message/rpt-compendium-default-message-dialog.html',
                    controller: 'RptCompendiumDefaultMessageDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                lowMessage: null,
                                highMessage: null,
                                normalMessage: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('rpt-compendium-default-message', null, { reload: 'rpt-compendium-default-message' });
                }, function() {
                    $state.go('rpt-compendium-default-message');
                });
            }]
        })
        .state('rpt-compendium-default-message.edit', {
            parent: 'rpt-compendium-default-message',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/rpt-compendium-default-message/rpt-compendium-default-message-dialog.html',
                    controller: 'RptCompendiumDefaultMessageDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['RptCompendiumDefaultMessage', function(RptCompendiumDefaultMessage) {
                            return RptCompendiumDefaultMessage.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('rpt-compendium-default-message', null, { reload: 'rpt-compendium-default-message' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('rpt-compendium-default-message.delete', {
            parent: 'rpt-compendium-default-message',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/rpt-compendium-default-message/rpt-compendium-default-message-delete-dialog.html',
                    controller: 'RptCompendiumDefaultMessageDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['RptCompendiumDefaultMessage', function(RptCompendiumDefaultMessage) {
                            return RptCompendiumDefaultMessage.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('rpt-compendium-default-message', null, { reload: 'rpt-compendium-default-message' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
